:host {
  width: 100%;
  height: 100%;
}

.wrapper {
  width: 100%;
  height: 100%;
  padding-top: calc(var(--spacer) * 2);
  display: block;

  .content-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;

    .bottom-buttons {
      width: 100%;
      flex-basis: 65px;
      min-height: 65px;
      margin-top: auto;
      display: flex;
      align-items: center;

      border-top: 1px solid var(--chart-101-pressed-dividers);

      padding-left: calc(var(--spacer) * 2);
      padding-right: calc(var(--spacer) * 2);

      gz-button {
        margin-right: calc(var(--spacer) * 2);
      }
    }
  }

  .loading-container {
    display: none;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    gz-progress-spinner {
      display: flex;
      justify-content: center;
    }
  }

  &.is-loading {
    .content-wrapper {
      display: none;
    }

    .loading-container {
      display: flex;
    }
  }
}

.header,
.panel-content {
  padding: 0 calc(var(--spacer) * 2) 0 calc(var(--spacer) * 2);
}

.section-title {
  color: var(--chart-300-icon-buttons);
}

.panel-content {
  flex: 2;
  overflow-y: auto;
  height: calc(100% - 124px);
  padding: 0 calc(var(--spacer) * 2) 0 calc(var(--spacer) * 2);

  & > * {
    height: auto;
    display: block;
    margin-top: var(--spacer);
    margin-bottom: calc(var(--spacer) * 2);

    &:not(:last-child) {
      border-bottom: 1px solid var(--chart-101-pressed-dividers);
    }
  }
}

gz-labeled-content {
  --label-width-percentage: 40%;
  --value-width-percentage: 60%;
  height: auto;
  margin-bottom: calc(var(--spacer) * 2);
}

gz-labeled-content::part(label) {
  color: var(--chart-300-icon-buttons);
  white-space: normal;
}

gz-labeled-content::part(content) {
  color: var(--body-text-arrows-400);
  margin-top: -2px;
}

gz-text[class='label-percentage'] {
  color: var(--green-layout-100-primary-green);
}

icon-value {
  color: var(--body-text-arrows-400);
}

#behavioral-profiles-button {
  margin-left: -20px;
  margin-top: -8px;
}

